// @flow strict
/* eslint-disable css-modules/no-undef-class */
import * as React from 'react';
import classnames from '@ta/common.classnames';
import styles from './CloseIcon.css';

/** CloseX color variants */
export type CloseIconColorVariant =
  | 'TA_GREEN'
  | 'TA_GREEN_DARK'
  | 'WHITE'
  | 'SEAT_GURU_BLUE'
  | 'TA_GRAY_3';

type Props = {|
  /** Callback fired when icon is clicked */
  onClick?: (SyntheticMouseEvent<HTMLDivElement>) => mixed,

  /** Callback fired when the Enter key is fired */
  onEnterKeyDown?: (SyntheticKeyboardEvent<HTMLDivElement>) => mixed,

  /** Color variant of the X */
  colorVariant?: CloseIconColorVariant,

  /** Use if you have a webdriver test that needs an attribute to select from to close the overlay. */
  testAttribute?: ?string,
|};

const getColorVariantClass = variant => {
  switch (variant) {
    case 'TA_GRAY_3':
      return styles.taGray3;
    case 'SEAT_GURU_BLUE':
      return styles.seatGuruBlue;
    case 'WHITE':
      return styles.inverted;
    case 'TA_GREEN_DARK':
      return styles.taGreenDark;
    case 'TA_GREEN':
    default:
      return null;
  }
};

/**
 * An X icon for an overlay that calls the callback prop when closed.
 */
const CloseIcon = ({
  colorVariant = 'TA_GREEN',
  onClick,
  onEnterKeyDown,
  testAttribute,
}: Props) => (
  <div
    className={classnames(styles.close, getColorVariantClass(colorVariant))}
    onClick={onClick}
    onKeyDown={event => {
      if (event.key === 'Enter' && onEnterKeyDown) {
        onEnterKeyDown(event);
      }
    }}
    data-test-attribute={testAttribute}
    role="button"
    tabIndex="0"
  />
);

export default CloseIcon;
